import { AddBomItemModalComponent } from "./add-bom-item-modal/add-bom-item-modal.component";
import { AlertsComponent } from "./alerts/alerts.component";
import { AlertsService } from "./alerts/alerts.service";
import { App } from "./app";
import { APP_TYPE } from "./app.type";
import { AppComponent } from "./app/app.component";
import { AppDateAdapter } from "./app-date-adapter";
import { ApplicationAreaComponent } from "./application-area/application-area.component";
import { ApplicationAreaService } from "./application-area/application-area.service";
import { AssignedToComponent } from "./assigned-to/assigned-to.component";
import { AttachmentComponent } from "./attachment/attachment.component";
import { AttachmentsComponent } from "./attachments/attachments.component";
import { AttachmentsControlsComponent } from "./attachments-controls/attachments-controls.component";
import { AttachmentService } from "./attachment/attachment.service";
import { AttachmentsService } from "./attachments/attachments.service";
import { AuthComponent } from "./auth/auth.component";
import { AuthImagePipe } from "./core/pipe/auth-image.pipe";
import { AuthService } from "./auth/auth.service";
import { AutosizeModule } from "ngx-autosize";
import { BoldPipe, HistoryComponent } from "./history/history.component";
import { BoxComponent } from "./box/box.component";
import { BrowserModule } from "@angular/platform-browser";
import { BusinessConfigComponent } from "./business-config/business-config.component";
import { BusinessConfigService } from "./business-config/business-config.service";
import { CaseControlsComponent } from "./case-controls/case-controls.component";
import { CellComponent } from "./cell/cell.component";
import { ChangesComponent } from "./changes/changes.component";
import { ChangesService } from "./changes/changes.service";
import { CommodityGroupResponsibleService } from "./commodity-group-responsible/commodity-group-responsible.service";
import { CreateManufacturerModalComponent } from "./create-manufacturer-modal/create-manufacturer-modal.component";
import { CreateManufacturerService } from "./create-manufacturer-modal/create-manufacturer-modal.service";
import { CreatePartModalComponent } from "./create-part-modal/create-part-modal.component";
import { CreditsComponent } from "./credits/credits.component";
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from "@angular/core";
import { CustomerEntraCardComponent } from "./customer-entra-card/customer-entra-card.component";
import { CustomersService } from "./customers/customers.service";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DashboardDataViewComponent } from "./dashboard/dashboard-data-view/dashboard-data-view.component";
import { DashboardRecordTableComponent } from "./dashboard/dashboard-record-table/dashboard-record-table.component";
import { DatesFilterComponent } from "./dates-filter/dates-filter.component";
import { DatesFilterService } from "./dates-filter/dates-filter.service";
import { DetailTableComponent } from "./part/detail-table/detail-table.component";
import { DetailTableService } from "./part/detail-table/detail-table.service";
import { DinCodeResponsibleService } from "./din-code-responsible/din-code-responsible.service";
import { DocsService } from "./docs/docs.service";
import { DocumentationComponent } from "./documentationURLs/documentation.component";
import { DragDropFilesComponent } from "./drag-drop-files/drag-drop-files.component";
import { EnvironmentService } from "./environment/environment.service";
import { ErrorComponent } from "./error/error.component";
import { ExpiredTokenInterceptor } from "./auth/expired-token.interceptor";
import { ExportDataComponent } from "./export-data/export-data.component";
import { ExtensionTokenInterceptor } from "./auth/extended-token.interceptor";
import { ExternalDataFilterComponent } from "./external-data-filter/external-data-filter.component";
import { ExternalDataFilterService } from "./external-data-filter/external-data-filter.service";
import { ExternalRedirectComponent } from "./external-redirect/external-redirect.component";
import { FieldComponent } from "./field/field.component";
import { FieldOptionsComponent } from "./field-options/field-options.component";
import { FieldService } from "./field/field.service";
import { FieldUserOptionsComponent } from "./field-user-options/field-user-options.component";
import { FileService } from "./file/file.service";
import { FilterDashboardComponent } from "./dashboard/filter-dashboard/filter-dashboard.component";
import { FilterDashboardService } from "./dashboard/filter-dashboard/filter-dashboard.service";
import { FilterFieldsComponent } from "./filter-fields/filter-fields.component";
import { FilterFieldsService } from "./filter-fields/filter-fields.service";
import { FilterHeaderTableComponent } from "./filter-header-table/filter-header-table.component";
import { FilterHeaderTableService } from "./filter-header-table/filter-header-table.service";
import { FilterListComponent } from "./filter-list/filter-list.component";
import { FilterListService } from "./filter-list/filter-list.service";
import { FilterService } from "./filter/filter.service";
import { FilterTableComponent } from "./filter-table/filter-table.component";
import { FilterTableService } from "./filter-table/filter-table.service";
import { FilterTreeComponent } from "./filter-tree/filter-tree.component";
import { FilterTreeService } from "./filter-tree/filter-tree.service";
import { FooterComponent } from "./footer/footer.component";
import { FooterService } from "./footer/footer.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FrameComponent } from "./frame/frame.component";
import { HeaderComponent } from "./header/header.component";
import { HeaderService } from "./header/header.service";
import { HistoryService } from "./history/history.service";
import { HomeComponent } from "./home/home.component";
import { HomeService } from "./home/home.service";
import { ImpactComponent } from "./impact/impact.component";
import { ImpactModalComponent } from "./impact-modal/impact-modal.component";
import { ImpactsComponent } from "./impacts/impacts.component";
import { ImpactService } from "./impact/impact.service";
import { ImpactsService } from "./impacts/impacts.service";
import { ImportComponent } from "./import/import.component";
import { ImportService } from "./import/import.service";
import { ImportStepperComponent } from "./import/import-stepper/import-stepper.component";
import { ImportXmlService } from "./import-xml/import-xml.service";
import { InternalItemsComponent } from "./internal-items/internal-items.component";
import { InternalItemsService } from "./internal-items/internal-items.service";
import { LeftNavComponent } from "./left-nav-component/left-nav.component";
import { LeftNavService } from "./left-nav-component/left-nav.service";
import { LimitComponent } from "./field/limit/limit.component";
import { ListOpenedCasesComponent } from "./thread/list-opened-cases/list-opened-cases.component";
import { MailComponent } from "./mail/mail.component";
import { MailService } from "./mail/mail.service";
import { ManufacturerCodeService } from "./manufacturer/manufacturer-code/manufacturer-code.service";
import { ManufacturerResponsibleService } from "./manufacturer/manufacturer-responsible/manufacturer-responsible.service";
import { ProductTypeResponsibleService } from "./part/product-type-responsible/product-type-responsible.service";
import { ManufacturerComponent } from "./manufacturer/manufacturer.component";
import { ManufacturerMatchingComponent } from "./manufacturer-matching/manufacturer-matching.component";
import { ManufacturerMatchingModalComponent } from "./manufacturer-matching-modal/manufacturer-matching-modal.component";
import { ManufacturerMatchingService } from "./manufacturer-matching/manufacturer-matching.service";
import { ManufacturerNameService } from "./manufacturer/manufacturer-name/manufacturer-name.service";
import { ManufacturerService } from "./manufacturer/manufacturer.service";
import { ManufacturersFilterTableComponent } from "./RM/manufacturers-filter-table/manufacturers-filter-table.component";
import { ManufacturersFilterTableService } from "./RM/manufacturers-filter-table/manufacturers-filter-table.service";
import { ManufacturerUtilsService } from "./manufacturer/manufacturer-utils.service";
import { MessageComponent } from "./message/message.component";
import { MessageItemComponent } from "./message-item/message-item.component";
import { MessageService } from "./message/message.service";
import { MFACompleteComponent } from "./MFA-complete/MFA-complete.component";
import { ModalComponent } from "./modal/modal.component";
import { NextComponent } from "./next/next.component";
import { NgbDateAdapter, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from "ngx-spinner";
import { NotFoundComponent } from "./not-found/not-found.component";
import { OCCommentComponent } from "./obsolescence-community/OC-comment/OC-comment.component";
import { OCCommentService } from "./obsolescence-community/OC-comment/OC-comment.service";
import { OCHomeComponent } from "./obsolescence-community/OC-home/OC-home.component";
import { OCHomeService } from "./obsolescence-community/OC-home/OC-home.service";
import { OCPostComponent } from "./obsolescence-community/OC-post/OC-post.component";
import { OCPostItemComponent } from "./obsolescence-community/OC-post-item/OC-post-item.component";
import { OCPostItemService } from "./obsolescence-community/OC-post-item/OC-post-item.service";
import { OCPostModalComponent } from "./obsolescence-community/OC-post-modal/OC-post-modal.component";
import { OCPostService } from "./obsolescence-community/OC-post/OC-post.service";
import { OperationsComponent } from "./operations/operations.component";
import { OperationsService } from "./operations/operations.service";
import { OverrideMpnFieldsModalComponent } from "./override-mpnFields-modal/override-mpnFields-modal.component";
import { OverrideMpnFieldsService } from "./override-mpnFields-modal/override-mpnFields.service";
import { PaginatorComponent } from "./paginator/paginator.component";
import { PaginatorService } from "./paginator/paginator.service";
import { PartComponent } from "./part/part.component";
import { PartService } from "./part/part.service";
import { PartsFilterTableComponent } from "./RM/parts-filter-table/parts-filter-table.component";
import { PartsFilterTableService } from "./RM/parts-filter-table/parts-filter-table.service";
import { PasswordComponent } from "./password/password.component";
import { PcnComponent } from "./pcn/pcn.component";
import { PcnGeneratorComponent } from "./pcn-generator/pcn-generator.component";
import { PcnGeneratorModalComponent } from "./pcn-generator/pcn-generator-modal/pcn-generator-modal.component";
import { PcnGeneratorService } from "./pcn-generator/pcn-generator.service";
import { PcnGeneratorStepBarComponent } from "./pcn-generator/pcn-generator-step-bar/pcn-generator-step-bar.component";
import { PcnHitoryComponent } from "./manufacturer/pcn-history-table/pcn-history-table.component";
import { PcnsComponent } from "./pcns/pcns.component";
import { PcnService } from "./pcn/pcn.service";
import { PcnsService } from "./pcns/pcns.service";
import { PersonService } from "./person/person.service";
import { PostComponent } from "./post/post.component";
import { PostItemComponent } from "./post-item/post-item.component";
import { PostService } from "./post/post.service";
import { PredefinedTasksComponent } from "./predefined-tasks/predefined-tasks.component";
import { ProductCategoryComponent } from "./product-category/product-category.component";
import { ProductCategoryService } from "./product-category/product-category.service";
import { ProfileComponent } from "./profile/profile.component";
import { ProfileService } from "./profile/profile.service";
import { provideUserIdleConfig } from "angular-user-idle";
import { ProxyService } from "./core/proxy/proxy.service";
import { ReleaseNotesModalComponent } from "./release-notes/release-notes-modal.component";
import { ReleaseNotesModalService } from "./release-notes/release-notes-modal.service";
import { ReleaseNotesBannerComponent } from "./release-notes-banner/release-notes-banner.component";
import { ReleaseNotesBannerService } from "./release-notes-banner/release-notes-banner.service";
import { ReplacementsTableComponent } from "./manufacturer/replacements-table/replacements-table.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { RMComponent } from "./RM/RM.component";
import { RMSearchComponent } from "./rm-search/rm-search.component";
import { RMSearchService } from "./rm-search/rm-search.service";
import { RMService } from "./RM/RM.service";
import { RMSubmenuComponent } from "./rm-submenu/rm-submenu.component";
import { RMSubmenuService } from "./rm-submenu/rm-submenu.service";
import { RouterModule } from "@angular/router";
import { routes } from "./routing/routes";
import { RoutingComponent } from "./routing/routing.component";
import { RoutingService } from "./routing/routing.service";
import { SafeHtmlPipe } from "./dashboard/dashboard-safe-html.pipe";
import { SectionCategoryComponent } from "./section-category/section-category.component";
import { SectionCategoryService } from "./section-category/section-category.service";
import { ServiceHelper } from "./injector";
import { SessionExpiresModalComponent } from "./session-expires-modal/session-expires-modal.component";
import { SettingsComponent } from "./settings/settings.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { SortByFieldComponent } from "./sort-by-field/sort-by-field.component";
import { SpinnerService } from "./core/spinner/spinner.service";
import { StateService } from "./state/state.service";
import { StepperComponent } from "./stepper/stepper.component";
import { StepperService } from "./stepper/stepper.service";
import { StockGraphicModalComponent } from "./stock-graphic-modal/stock-graphic-modal.component";
import { SupplyChainComponent } from "./manufacturer/supply-chain-table/supply-chain-table.component";
import { SVHCItemsComponent } from "./SVHC-items/SVHC-items.component";
import { SVHCItemsService } from "./SVHC-items/SVHC-items.service";
import { SyncComponent } from "./sync/sync.component";
import { SyncService } from "./sync/sync.service";
import { TransferComponent } from "./transfer/transfer.component";
import { TransferService } from "./transfer/transfer.service";
import { TableComponent } from "./table/table.component";
import { TableService } from "./table/table.service";
import { TaskCompletedNoteComponent } from "./task-completed-note/task-completed-note.component";
import { TaskCompletedService } from "./task-completed-note/task-completed.service";
import { TaskItemsComponent } from "./task-items/task-items.component";
import { TaskPanelComponent } from "./task-panel/task-panel.component";
import { TaskPanelService } from "./task-panel/task-panel.service";
import { TasksComponent } from "./tasks/tasks.component";
import { TasksService } from "./tasks/tasks.service";
import { ThreadComponent } from "./thread/thread.component";
import { ThreadItemComponent } from "./thread-item/thread-item.component";
import { ThreadService } from "./thread/thread.service";
import { TokenInterceptor } from "./auth/token.interceptor";
import { TrainComponent } from "./train/train.component";
import { TrainseriesComponent } from "./trainseries/trainseries.component";
import { TrainService } from "./train/train.service";
import { TrainsListComponent } from "./trains-list/trains-list.component";
import { TrainsModalComponent } from "./trains-modal/trains-modal.component";
import { TreeCellComponent } from "./tree-cell/tree-cell.component";
import { TreeCellService } from "./tree-cell/tree-cell.service";
import { TreeComponent } from "./tree/tree.component";
import { TreeRowComponent } from "./tree-row/tree-row.component";
import { TreeRowService } from "./tree-row/tree-row.service";
import { TreeService } from "./tree/tree.service";
import { TypeAheadBasicComponent } from "./field/type-ahead/typeahead-basic.component";
import { TypeAheadBasicService } from "./field/type-ahead/typeahead-basic.service";
import { UnlockComponent } from "./unlock/unlock.component";
import { UserComponent } from "./user/user.component";
import { UserLinkComponent } from "./user-link/user-link.component";
import { UserProfileListComponent } from "./user-profile-list/user-profile-list.component";
import { UsersComponent } from "./users/users.component";
import { UserSettingsComponent } from "./user-settings/user-settings.component";
import { UserSettingsService } from "./user-settings/user-settings.service";
import { UsersService } from "./users/users.service";
import { VehicleResponsibleComponent } from "./vehicle-responsible/vehicle-responsible.component";
import { VehicleResponsibleListComponent } from "./vehicle-responsible-list/vehicle-responsible-list.component";
import { VehicleResponsibleModalComponent } from "./vehicle-responsible-modal/vehicle-responsible-modal.component";
import { VehicleResponsibleService } from "./vehicle-responsible/vehicle-responsible.service";
import { WarehouseGroupComponent } from "./warehouse-group/warehouse-group.component";
import { WarehouseGroupService } from "./warehouse-group/warehouse-group.service";
import { WhereUsedTreeComponent } from "./where-used-tree/where-used-tree.component";
import { WhereUsedInComponent } from "./impacts/where-used-in/where-used-in.component";
import { WorkflowAutomationComponent } from "./impact/wf-automation/wf-automation.component";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from "@angular/common/http";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    TaskPanelComponent,
    FooterComponent,
    ExportDataComponent,
    HomeComponent,
    SettingsComponent,
    ProfileComponent,
    MailComponent,
    UsersComponent,
    ThreadItemComponent,
    ThreadComponent,
    BoxComponent,
    PostItemComponent,
    PostComponent,
    CellComponent,
    TableComponent,
    UserComponent,
    FrameComponent,
    PaginatorComponent,
    TreeCellComponent,
    ImportComponent,
    ImportStepperComponent,
    FilterListComponent,
    FieldComponent,
    LimitComponent,
    PasswordComponent,
    NextComponent,
    ImpactsComponent,
    AttachmentsComponent,
    AttachmentComponent,
    AuthComponent,
    MFACompleteComponent,
    ErrorComponent,
    ModalComponent,
    TreeComponent,
    AlertsComponent,
    StepperComponent,
    CreditsComponent,
    ImpactComponent,
    WhereUsedInComponent,
    WhereUsedTreeComponent,
    WorkflowAutomationComponent,
    ListOpenedCasesComponent,
    UserLinkComponent,
    AttachmentsControlsComponent,
    CaseControlsComponent,
    FieldOptionsComponent,
    FieldUserOptionsComponent,
    SyncComponent,
    TransferComponent,
    UnlockComponent,
    HistoryComponent,
    VehicleResponsibleListComponent,
    VehicleResponsibleComponent,
    RoutingComponent,
    SortByFieldComponent,
    PcnComponent,
    InternalItemsComponent,
    PartComponent,
    DetailTableComponent,
    RMComponent,
    RMSearchComponent,
    OperationsComponent,
    ManufacturerComponent,
    ManufacturerMatchingComponent,
    ManufacturerMatchingModalComponent,
    CreateManufacturerModalComponent,
    OverrideMpnFieldsModalComponent,
    ReplacementsTableComponent,
    PcnHitoryComponent,
    ExternalDataFilterComponent,
    LeftNavComponent,
    MessageComponent,
    MessageItemComponent,
    UserProfileListComponent,
    ManufacturersFilterTableComponent,
    RMSubmenuComponent,
    TrainsListComponent,
    TrainComponent,
    TrainseriesComponent,
    BoldPipe,
    FilterTableComponent,
    FilterHeaderTableComponent,
    AuthImagePipe,
    TasksComponent,
    PcnsComponent,
    ChangesComponent,
    FilterTreeComponent,
    FilterFieldsComponent,
    ApplicationAreaComponent,
    TaskCompletedNoteComponent,
    AttachmentComponent,
    PcnGeneratorComponent,
    PcnGeneratorModalComponent,
    PcnGeneratorStepBarComponent,
    StockGraphicModalComponent,
    ResetPasswordComponent,
    SVHCItemsComponent,
    TypeAheadBasicComponent,
    ImpactModalComponent,
    TrainsModalComponent,
    VehicleResponsibleModalComponent,
    SessionExpiresModalComponent,
    NotFoundComponent,
    DocumentationComponent,
    ProductCategoryComponent,
    PartsFilterTableComponent,
    PredefinedTasksComponent,
    UserSettingsComponent,
    CreatePartModalComponent,
    AddBomItemModalComponent,
    TreeRowComponent,
    AssignedToComponent,
    TaskItemsComponent,
    SupplyChainComponent,
    OCHomeComponent,
    OCPostComponent,
    OCCommentComponent,
    OCPostItemComponent,
    OCPostModalComponent,
    ReleaseNotesModalComponent,
    ReleaseNotesBannerComponent,
    DashboardComponent,
    DashboardDataViewComponent,
    DashboardRecordTableComponent,
    FilterDashboardComponent,
    BusinessConfigComponent,
    WarehouseGroupComponent,
    DragDropFilesComponent,
    // Pipes used in the app
    SafeHtmlPipe,
    SectionCategoryComponent,
    DatesFilterComponent,
    CustomerEntraCardComponent,
    ExternalRedirectComponent
  ],
  exports: [AuthImagePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [RoutingComponent],
  imports: [
    NgxSpinnerModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes),
    NgbModule,
    AutosizeModule
  ],
  providers: [
    {
      provide: NgbDateAdapter,
      useClass: AppDateAdapter
    },
    {
      provide: APP_TYPE,
      useClass: App
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExtensionTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExpiredTokenInterceptor,
      multi: true
    },
    /** expiration of the token for 1h -3600s */
    provideUserIdleConfig({ idle: 1, timeout: 3600, ping: 60 }),
    AuthService,
    DocsService,
    FieldService,
    HomeService,
    ImpactService,
    ImpactsService,
    UsersService,
    UserSettingsService,
    ProfileService,
    TableService,
    PaginatorService,
    MailService,
    RoutingService,
    CustomersService,
    StateService,
    FileService,
    DinCodeResponsibleService,
    CommodityGroupResponsibleService,
    ThreadService,
    PcnService,
    VehicleResponsibleService,
    PostService,
    PartService,
    RMService,
    RMSearchService,
    OperationsService,
    ManufacturerService,
    CreateManufacturerService,
    ManufacturerMatchingService,
    TreeService,
    TreeCellService,
    TreeRowService,
    LeftNavService,
    MessageService,
    AlertsService,
    ManufacturersFilterTableService,
    PartsFilterTableService,
    RMSubmenuService,
    ImportService,
    FilterListService,
    PersonService,
    TrainService,
    FilterTableService,
    FilterHeaderTableService,
    ProxyService,
    SpinnerService,
    TasksService,
    FilterTreeService,
    FilterFieldsService,
    SyncService,
    TransferService,
    StepperService,
    PcnsService,
    InternalItemsService,
    ExternalDataFilterService,
    ApplicationAreaService,
    TaskCompletedService,
    AttachmentService,
    PcnGeneratorService,
    AttachmentsService,
    HeaderService,
    HistoryService,
    OverrideMpnFieldsService,
    ManufacturerUtilsService,
    SVHCItemsService,
    ImportXmlService,
    ChangesService,
    DetailTableService,
    ProductCategoryService,
    ManufacturerNameService,
    ManufacturerCodeService,
    ManufacturerResponsibleService,
    ProductTypeResponsibleService,
    FilterService,
    TaskPanelService,
    TypeAheadBasicService,
    OCHomeService,
    OCPostService,
    OCCommentService,
    OCPostItemService,
    ReleaseNotesModalService,
    ReleaseNotesBannerService,
    FooterService,
    BusinessConfigService,
    WarehouseGroupService,
    FilterDashboardService,
    SectionCategoryService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    EnvironmentService,
    DatesFilterService
  ]
})
export class AppModule {
  constructor(injector: Injector) {
    ServiceHelper.injector = injector;
  }
}
